export enum MeetingAttendanceStatusEnum {
  YES = 'yes',
  ON_ANOTHER_MEETING = 'on_another_meeting',
  YES_BUT_LATE = 'yes_but_late',
  NO = 'no',
  DONT_KNOW = 'dont_know',
  FORCE_MAJEURE = 'force_majeure',
  DIDNT_HAVE_TO_ATTEND = 'didnt_have_to_attend',
}

export const MeetingAttendanceStatusLabels: Record<string, string> = {
  [MeetingAttendanceStatusEnum.YES]: 'Sí',
  [MeetingAttendanceStatusEnum.ON_ANOTHER_MEETING]: 'Estaba en otra reunión',
  [MeetingAttendanceStatusEnum.YES_BUT_LATE]: 'Sí, pero tarde',
  [MeetingAttendanceStatusEnum.NO]: 'No',
  [MeetingAttendanceStatusEnum.DONT_KNOW]: 'No lo sé',
  [MeetingAttendanceStatusEnum.FORCE_MAJEURE]: 'No, por fuerza mayor',
  [MeetingAttendanceStatusEnum.DIDNT_HAVE_TO_ATTEND]: 'No tenía que asistir',
};
